import React, { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "./utils";

const LoginView = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück, Keeper!");
    } catch (err) {
      const detail = err.response?.data?.detail || err.message;
      toast.error(typeof detail === "string" ? detail : "Login fehlgeschlagen");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-black flex items-center justify-center px-6"
      data-testid="admin-login-view"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img
            src={LOGO_URL}
            alt="4keeperz"
            className="h-24 md:h-28 w-auto mx-auto object-contain"
            data-testid="admin-login-logo"
          />
          <div className="mt-4 font-condensed uppercase tracking-[0.3em] text-xs text-white/50">
            Admin Control Center
          </div>
        </div>

        <form
          onSubmit={onSubmit}
          data-testid="admin-login-form"
          className="bg-[#0A0A0A] border border-white/10 p-8 space-y-5"
        >
          <div className="flex items-center gap-3 mb-2">
            <Lock className="w-5 h-5 text-[#00A651]" />
            <span className="font-condensed uppercase tracking-widest text-sm text-white/70">
              Anmelden
            </span>
          </div>

          <div>
            <label className="block font-condensed uppercase tracking-widest text-[10px] text-white/50 mb-2">
              E-Mail
            </label>
            <input
              type="email"
              required
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-black border border-white/15 focus:border-[#00A651] outline-none px-4 py-3 text-white transition-colors"
            />
          </div>

          <div>
            <label className="block font-condensed uppercase tracking-widest text-[10px] text-white/50 mb-2">
              Passwort
            </label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-black border border-white/15 focus:border-[#00A651] outline-none px-4 py-3 text-white transition-colors"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-3 bg-[#00A651] hover:bg-[#008A43] disabled:opacity-50 text-black font-condensed uppercase tracking-[0.2em] px-8 py-4 transition-colors"
          >
            {submitting ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Wird angemeldet...
              </>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginView;
